
export const MOVIE_FETCH_START = 'MOVIE_FETCH_START';
export const MOVIE_FETCH_RES = 'MOVIE_FETCH_RES';
export const MOVIE_FETCH_ERR = 'MOVIE_FETCH_ERR';


export const GENRE_FETCH_START = 'GENRE_FETCH_START';
export const GENRE_FETCH_RES = 'GENRE_FETCH_RES';
export const GENRE_FETCH_ERROR = 'GENRE_FETCH_ERROR';


export const NOW_PLAYING_FECTH_START = 'NOW_PLAYING_FECTH_START'
export const NOW_PLAYING_RES = 'NOW_PLAYING_RES'
export const NOW_PLAYING_ERR = 'NOW_PLAYING_ERR'

export const CATEGORIES_FECTH_START = 'CATEGORIES_FECTH_START';
export const CATEGORIES_RES = 'CATEGORIES_RES';
export const CATEGORIES_ERR = 'CATEGORIES_ERR';


export const TOP_CHART_FETCH_START = 'TOP_CHART_FETCH_START'
export const TOP_CHART_RES = 'TOP_CHART_RES';
export const TOP_CHART_ERR = 'TOP_CHART_ERR';

export const NEW_RELEASE_FETCH_START = 'NEW_RELEASE_FETCH_START';
export const NEW_RELEASE_RES = 'NEW_RELEASE_RES';
export const NEW_RELEASE_ERR = 'NEW_RELEASE_ERR'


export const GUEST_SESSION_FETCH_START = 'GUEST_SESSION_FETCH_START';
export const GUEST_SESSION_RES = 'GUEST_SESSION_RES';
export const GUEST_SESSION_ERR = 'GUEST_SESSION_ERR'; 
export const GUEST_SESSION_LOG_OUT = 'GUEST_SESSION_LOG_OUT';

export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS';
export const SET_LOGIN_MODAL = 'SET_LOGIN_MODAL';

export const GET_FAV_MOVIES = 'GET_FAV_MOVIES';

export const GET_WISHLIST_MOVIES = 'GET_WISHLIST_MOVIES';


export const GET_DETAILS_FETCH_START = 'GET_DETAILS_FETCH_START';
export const GET_DETAILS_RES = 'GET_DETAILS_RES';
export const GET_DETAILS_ERR = 'GET_DETAILS_ERR';

export const GET_RECOMMENDATIONS_RES = 'GET_RECOMMENDATIONS_RES';
export const GET_RECOMMENDATIONS_ERR = 'GET_RECOMMENDATIONS_ERR';


export const SEARCH_FETCH_START = 'SEARCH_FETCH_START';
export const SEARCH_RES = 'SEARCH_RES';
export const SEARCH_ERR = 'SEARCH_ERR';